/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KeyFinding } from './keyFinding';


/**
 * A titled card with a prose paragraph, a bullet list of highlights, and an optional footnote. Surfaces a narrative summary alongside structured data blocks within a tab.
 */
export interface ContentCardBlock { 
    /**
     * Discriminator identifying this block as a content card.
     */
    type?: ContentCardBlock.TypeEnum;
    /**
     * Optional card heading, for example the insight title.
     */
    title?: string | null;
    /**
     * Optional prose paragraph displayed below the title.
     */
    text?: string | null;
    /**
     * Bullet-point highlights displayed as a list beneath the paragraph. Uses the same label/value/metric structure as summary card key findings.
     */
    highlights?: Array<KeyFinding>;
    /**
     * Optional caption at the bottom of the card, for example a data freshness note.
     */
    footnote?: string | null;
}
export namespace ContentCardBlock {
    export const TypeEnum = {
        ContentCard: 'content-card'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


